function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 12C0 5.3772 5.376 0 12 0C18.636 0 24 5.3772 24 12C24 18.6252 18.636 24 12 24C5.376 24 0 18.6252 0 12ZM10.9442 7.45231C10.9442 6.87751 11.4242 6.39631 12.0002 6.39631C12.5762 6.39631 13.0442 6.87751 13.0442 7.45231V12.7563C13.0442 13.3335 12.5762 13.8003 12.0002 13.8003C11.4242 13.8003 10.9442 13.3335 10.9442 12.7563V7.45231ZM12.012 17.6172C11.424 17.6172 10.956 17.1372 10.956 16.5612C10.956 15.9852 11.424 15.5172 12 15.5172C12.588 15.5172 13.056 15.9852 13.056 16.5612C13.056 17.1372 12.588 17.6172 12.012 17.6172Z",
  fill: "#F65164"
});

var SvgAlertErrorIcon = function SvgAlertErrorIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlertErrorIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AlertErrorIcon.7ddf047b.svg";
export { ForwardRef as ReactComponent };